// Color tokens that distinguish workspace-owner identity from agent identity
// across mention pills, member lists, and any future surface that names a
// participant. Centralized so KTK-201 (in-chat mentions) and KTK-200 (channel
// roster tooltip) stay in sync.
export const OWNER_PILL_COLOR = "#f59f00";
export const OWNER_PILL_BG = "rgba(245, 159, 0, 0.18)";
export const AGENT_PILL_COLOR = "var(--accent)";
export const AGENT_PILL_BG = "rgba(124, 92, 252, 0.2)";
//# sourceMappingURL=identity.js.map